<div class=" flex gap-8 align-items-center justify-content-start w-screen h-screen not_found_container">
  <div class="error_container flex flex-column justify-content-start w-5">
    <h3 class="text-5xl text-color font-semibold m-0 p-0">Oops! Something went wrong.</h3>
    <p class="text-color  mx-0 mt-2 mb-2 p-0 line-height-2 text-lg font-medium">
      We encountered an issue and couldn’t complete your request.
    </p>
    <p class="text-sm mx-0 mt-0 mb-2 p-0 text-gray-700">There was an issue while retrieving your data. Some transactions may not have loaded correctly. Please reload the page. If the problem persists, wait a few minutes and try again.</p>
    <div class="flex gap-2 align-items-center cursor-pointer mt-3">
      <svg-icon key="refresh" color="--primary-color" class="text-primary">refresh</svg-icon>
      <a class="no-underline text-primary text-sm" routerLink="/"
        >Refresh page</a
      >
    </div>

  <!-- <p-button (onClick)="reloadPage()" styleClass="text-xs border-round mt-3" label="Reload"/> -->

  </div>
</div>
